module.exports = __webpack_public_path__ + "img/072-hurricane-1.748efd5a.svg";